import { myAccountViewStyles } from "@insite/content-library/Widgets/MyAccount/MyAccountView";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

myAccountViewStyles.quickLinksGridItem = {
    width: [12, 12, 12, 2, 2],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 15px 20px;
                `,
                css`
                    padding: 15px 20px;
                `,
                css`
                    padding: 15px 20px;
                `,
                css``,
                null,
            ])}
    `,
};
myAccountViewStyles.mainSectionGridItem = {
    width: [12, 12, 12, 10, 10],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 0 20px;
                `,
                css`
                    padding: 0 20px;
                `,
                css`
                    padding: 0 20px;
                `,
                css``,
                null,
            ])}
    `,
};
